export const PREFERRED_PRODUCT_FAMILY = 'PREFERRED_PRODUCT_FAMILY';
export const LAST_ORDERED_ORDERS = 'LAST_ORDERED_ORDERS';
export const SINGLE_ORDER_PAGE_DISPLAY_MODE = 'SINGLE_ORDER_PAGE_DISPLAY_MODE';
export const COMPANY_PAGE_DISPLAY_MODE = 'COMPANY_PAGE_DISPLAY_MODE';
export const WISHLIST_PAGE_DISPLAY_MODE = 'WISHLIST_PAGE_DISPLAY_MODE';
